/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';

/*------------------------------------*\
    FAQ ACCORDION
\*------------------------------------*/
class Accordion {
    constructor(passedElement) {
        let self = this;
        self.elem = passedElement;
    }

    /*-------------------------------------------------*\
        INIT
    \*-------------------------------------------------*/
    init() {
        let self = this;

        $('#faq-accordion').collapse()
    };
}

export default Accordion;